export default __webpack_public_path__ + "static/media/rocket image.8d228df2.png";